import { Button, Grid, Row, Form, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import React, { PureComponent } from "react";
import * as endpoints from "../../lib/api/stores";
import Loader from "../Loader";

const strings = {
    title: "Menu Import",
    storeNumbers: "Store Ids",
    enterstoreNumbers: "Enter a list of comma separated storeNumbers",
    emails: "Emails",
    enterEmails: "Enter a list of comma separated emails",
    bhwEmail: "pfrancis@thebhwgroup.com",
    loadingMessage: "Please give a moment for the store menu import request to complete",
};

export default class StoreImportPage extends PureComponent {
    state = {
        storeNumbers: "",
        emails: "",
        loading: false,
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _onstoreNumbersChange = e => {
        this.setState({ storeNumbers: e.target.value });
    };

    _onEmailsChange = e => {
        this.setState({ emails: e.target.value });
    };

    _onClickImport = () => {
        this.setState({ loading: true });
        let validStoreNumbers = true;
        const storeList = this.state.storeNumbers.split(",").map(storeNumber => {
            const parsedStoreNumber = parseInt(storeNumber);
            if (isNaN(parsedStoreNumber)) {
                validStoreNumbers = false;
            }
            return parsedStoreNumber;
        });
        const emailList = this.state.emails.split(",");
        emailList.push("pfrancis@thebhwgroup.com");
        if (!validStoreNumbers) {
            alert("The store numbers you have entered are not valid. Please try again.");
        } else {
            endpoints
                .importStoreMenus(storeList, emailList)
                .then(() => {
                    alert(
                        "The import was successful. A mail should have been sent to all recipients listed below.",
                    );
                })
                .catch(err => {
                    alert(
                        `An error occurred with status code: ${err.response.status}. Please try again later.`,
                    );
                })
                .finally(() => {
                    this.setState({ loading: false });
                });
        }
    };

    render() {
        if (this.state.loading) {
            return (
                <Grid>
                    <Row>
                        <h3>{strings.title}</h3>
                    </Row>
                    <Row>{strings.loadingMessage}</Row>
                    <Loader />
                </Grid>
            );
        }
        return (
            <Grid>
                <Row>
                    <h3>{strings.title}</h3>
                </Row>
                <Row>
                    <Form onSubmit={this._onClickImport}>
                        <FormGroup controlId="storeList">
                            <ControlLabel>{strings.storeNumbers}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.storeNumbers}
                                placeholder={strings.enterstoreNumbers}
                                onChange={this._onstoreNumbersChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>{strings.emails}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.emails}
                                placeholder={strings.enterEmails}
                                onChange={this._onEmailsChange}
                            />
                        </FormGroup>
                        <Button
                            variant="primary"
                            onClick={this._onClickImport}
                            disabled={
                                this.state.loading || !this.state.storeNumbers || !this.state.emails
                            }
                        >
                            Import Menus
                        </Button>
                    </Form>
                </Row>
            </Grid>
        );
    }
}
